module.exports = __webpack_public_path__ + "static/media/epark-street-selected.8731837f.svg";